import { lazy } from "react";

const SystemPaymentsPage = lazy(() => import("@/widgets/system-admin/payments/PaymentsPage"));

const SystemPaymentRoutes = {
  path: "payments",
  children: [{ index: true, element: <SystemPaymentsPage /> }],
};

export default SystemPaymentRoutes;
